import {pillowLayout} from './design/configurator/room/pillow-layout';
import type {BasicUpgrades} from '../../../shared/basicUpgrades';
export type AssemblyPart={x:number;y:number;z:number;w:number;h:number;d:number;group:number;kind:string;dx:number;dy:number;dz:number;rot:number;delay:number;pitch?:number;yaw?:number};
export function buildAssembly(choice:number,stairs:boolean,upgrades:BasicUpgrades={},ceilingInches=96):AssemblyPart[]{
let parts:AssemblyPart[]=[];
function add(x:number,y:number,z:number,w:number,h:number,d:number,group:number,kind='frame'){const i=parts.length;parts.push({x,y,z,w,h,d,group,kind,dx:(i%2?1:-1)*(65+i%4*12),dy:group===0?25:group===1?-22:45,dz:(i%3-1)*65,rot:(i%2?1:-1)*(.65+(i%3)*.35),delay:group*1.1+(i%4)*.12});}
function ladderBuild(){parts=[];const sizes=[[39,39,75],[39,39,80],[39,54,75],[39,60,80],[60,60,80],[54,54,75]], [upper,lower,len]=sizes[choice]||sizes[0],L=len+6,D=lower+6,U=upper+6,back=-D/2,topZ=back+U/2;
// Two 1x6 faces form each corner wrap; each outer leg spans 5.5 inches.
function cornerWrap(sx:number,z:number,sz:number,height:number){
  add(sx*(L/2-.375),height/2,z-sz*2.75,.75,height,5.5,0);
  add(sx*(L/2-3.125),height/2,z-sz*.375,4.75,height,.75,0);
}
for(const sx of [-1,1]){cornerWrap(sx,back,-1,80);cornerWrap(sx,back+U,1,80);}
// Lower frame and upper platform.
for(const [y,dep,zc] of [[12,D,0],[59,U,topZ]]){
  const lowerFrame=y===12;
  // White platform is recessed inside the side boards, with no exposed raw edge.
  add(0,y,zc,L-6,2,dep-6,1,'frame');
  if(lowerFrame){
    // One continuous level perimeter: both directions share top and bottom edges.
    // End boards cap the long boards; all seams sit underneath the corner wraps.
    // Preserve the apron top and mattress height; extend the base down to y=0.
    const baseHeight=y+1+4.5;
    for(const z of [-dep/2+1.125,dep/2-1.125])add(0,baseHeight/2,z,L-3,baseHeight,.75,1);
    for(const x of [-L/2+1.125,L/2-1.125])add(x,baseHeight/2,zc,.75,baseHeight,dep-1.5,1);
  }else{
    for(const z of [zc-dep/2+1,zc+dep/2-1])add(0,y+1,z,L-2,7,2,1);
    for(const x of [-L/2+1,L/2-1])add(x,y+1,zc,2,7,dep-2,1);
  }
}
if(D>U)for(const sx of [-1,1])cornerWrap(sx,D/2,1,19);
// Upper guardrails; foot-end opening reserved for ladder.
for(const y of [70,78]){
  for(const z of [back+1,back+U-1])add(0,y,z,L-4,3,1.5,2);
  add(-L/2+1,y,topZ,1.5,3,U-2,2);
  // Foot guardrails terminate against the ladder uprights, leaving entry clear.
  add(L/2-1,y,back+(U-19)/2,1.5,3,U-21,2);
  add(L/2-1,y,back+U-1.5,1.5,3,1,2);
}
// Foot-end ladder pieces enter as a final group.
const ladderZ=back+U-11;
for(const z of [ladderZ-8,ladderZ+8])add(L/2-1,40,z,3,80,2,3);
for(let y=9;y<60;y+=10)add(L/2-1,y,ladderZ,3,2,14,3);
add(0,18,0,len,8,lower,4,'mattress');add(0,65,topZ,len,8,upper,4,'mattress');
for(const [width,y,zc] of [[lower,23,0],[upper,70,topZ]]){
  const pillows=pillowLayout(width),offsets=pillows.offsets;
  for(const offset of offsets)add(-len/2+pillows.depth/2+3,y+1.5,zc+offset,pillows.depth,5,pillows.width,4,'pillow');
}
}
function stairsBuild(){parts=[];const sizes=[[39,39,75],[39,39,80],[39,54,75],[39,60,80],[60,60,80],[54,54,75]], [upper,lower,len]=sizes[choice]||sizes[0],L=len+6,D=lower+6,U=upper+6,back=-D/2,topZ=back+U/2;
// Two 1x6 faces form each corner wrap; each outer leg spans 5.5 inches.
function cornerWrap(sx:number,z:number,sz:number,height:number){
  add(sx*(L/2-.375),height/2,z-sz*2.75,.75,height,5.5,0);
  add(sx*(L/2-3.125),height/2,z-sz*.375,4.75,height,.75,0);
}
for(const sx of [-1,1]){cornerWrap(sx,back,-1,80);cornerWrap(sx,back+U,1,80);}
// Lower frame and upper platform.
for(const [y,dep,zc] of [[12,D,0],[59,U,topZ]]){
  const lowerFrame=y===12;
  // White platform is recessed inside the side boards, with no exposed raw edge.
  add(0,y,zc,L-6,2,dep-6,1,'frame');
  if(lowerFrame){
    // One continuous level perimeter: both directions share top and bottom edges.
    // End boards cap the long boards; all seams sit underneath the corner wraps.
    // Preserve the apron top and mattress height; extend the base down to y=0.
    const baseHeight=y+1+4.5;
    for(const z of [-dep/2+1.125,dep/2-1.125])add(0,baseHeight/2,z,L-3,baseHeight,.75,1);
    for(const x of [-L/2+1.125,L/2-1.125])add(x,baseHeight/2,zc,.75,baseHeight,dep-1.5,1);
  }else{
    for(const z of [zc-dep/2+1,zc+dep/2-1])add(0,y+1,z,L-2,7,2,1);
    add(-L/2+1,y+1,zc,2,7,dep-2,1);
    // Foot apron finishes flush with the landing/deck, not above the entry.
    add(L/2-1,56.5,zc,2,7,dep-2,1);
  }
}
if(D>U)for(const sx of [-1,1])cornerWrap(sx,D/2,1,19);
// The 21-inch landing depth defines the bed-side entry; stair width is 24 inches.
// Rear outside face of the landing rail shares the upper rear rail's wall plane.
const rearRailZ=back+1,entryStart=rearRailZ+.75,entryEnd=entryStart+21,entryZ=(entryStart+entryEnd)/2;
// Continuous long-side/head rails; foot rail returns stop at the entry jambs.
for(const y of [70,78]){
  for(const z of [back+1,back+U-1])add(0,y,z,L-4,3,1.5,2);
  add(-L/2+1,y,topZ,1.5,3,U-2,2);
  add(L/2-.75,y,(back+.75+entryStart)/2,1.5,3,entryStart-back-.75,2);
  add(L/2-.75,y,(entryEnd+back+U-.75)/2,1.5,3,back+U-.75-entryEnd,2);
}
for(const z of [entryStart-.375,entryEnd+.375])add(L/2-.75,70,z,1.5,20,.75,2);
// White threshold bridges the recessed deck to the staircase landing, top at 60.
add(L/2-1.5,59,entryZ,3,2,21,1);
const stairFirst=parts.length,landingX=L/2,stairX=landingX+12;
const railThickness=1.5,outerRailX=landingX+24-railThickness/2;
const rearGuardZ=entryStart-railThickness/2,frontGuardZ=entryEnd-railThickness/2;
// Keep the 21-inch clear landing/entry; support the rear guard on the deck too.
// Its rear face stays aligned with the bunk's rear rail, while the outside face
// and front post finish flush with the staircase rather than floating past it.
const landingDepth=21+railThickness,landingZ=entryZ-railThickness/2;
add(stairX,29.25,landingZ,24,58.5,landingDepth,3);
add(stairX,59.25,landingZ,24,1.5,landingDepth,3);
for(let i=0;i<4;i++){
  const top=48-i*12,z=entryEnd+i*12+6;
  add(stairX,(top-1.5)/2,z,24,top-1.5,12,3);
  add(stairX,top-.75,z,24,1.5,12,3);
}
// Back and outside landing rails leave the bed-side opening unobstructed.
for(const y of [70,78]){
  add(landingX+(24-railThickness)/2,y,rearGuardZ,24-railThickness,3,railThickness,3);
  add(outerRailX,y,(rearGuardZ+frontGuardZ)/2,railThickness,3,frontGuardZ-rearGuardZ-railThickness,3);
}
add(outerRailX,70,rearGuardZ,railThickness,20,railThickness,3);
// Basic staircase: no sloped handrails or handrail support posts.
// The outer landing guard ends at its own short post.
add(outerRailX,70,frontGuardZ,railThickness,20,railThickness,3);
// The staircase slides in as a single aligned assembly.
for(const p of parts.slice(stairFirst)){p.dx=100;p.dy=0;p.dz=0;p.rot=0;p.delay=3.3;}
add(0,18,0,len,8,lower,4,'mattress');add(0,65,topZ,len,8,upper,4,'mattress');
for(const [width,y,zc] of [[lower,23,0],[upper,70,topZ]]){
  const pillows=pillowLayout(width),offsets=pillows.offsets;
  for(const offset of offsets)add(-len/2+pillows.depth/2+3,y+1.5,zc+offset,pillows.depth,5,pillows.width,4,'pillow');
}
}
if(stairs)stairsBuild();else ladderBuild();
const sizes=[[39,39,75],[39,39,80],[39,54,75],[39,60,80],[60,60,80],[54,54,75]], [upper,lower,len]=sizes[choice]||sizes[0],L=len+6,D=lower+6,U=upper+6,back=-D/2,zc=back+U/2,top=Math.max(84,Math.min(240,ceilingInches));
if(upgrades.towerSoffit){
 for(const x of [-L/2+.375,L/2-.375])for(const z of [back+2.75,back+U-2.75])add(x,(80+top)/2,z,.75,top-80,5.5,5);
 for(const x of [-L/2+3.125,L/2-3.125])for(const z of [back+.375,back+U-.375])add(x,(80+top)/2,z,4.75,top-80,.75,5);
 add(0,top-3,zc,L,6,U,5,'soffit');
}
for(const [enabled,y] of [[upgrades.puckUpper,upgrades.towerSoffit?top-6:top],[upgrades.puckLower,58]] as const){
 if(!enabled)continue;
 // Match the room preview: four fixtures, equally inset along both axes.
 for(const x of [-L/4,L/4])for(const z of [back+U/4,back+U*3/4]){
  add(x,y-.325,z,4,.65,4,5,'puck-rim');
  add(x,y-.71,z,3.3,.12,3.3,5,'puck-lens');
 }
}
if(stairs&&upgrades.stairDrawers){
 const entryEnd=back+1.75+21,stairX=L/2+12;
 for(let i=0;i<4;i++){const y=48-i*12,z=entryEnd+(i+1)*12;add(stairX,y-6,z+.15,21,9,.3,3,'drawer');add(stairX,y-6,z+.5,4,.5,.5,3,'hardware');}
}
return parts;
}



